export const UPLOAD_BANNER_IMAGE_REQUEST = 'UPLOAD_IMAGE_REQUEST';
export const UPLOAD_BANNER_IMAGE_SUCCESS = 'UPLOAD_IMAGE_SUCCESS';
export const UPLOAD_BANNER_IMAGE_FAILED = 'UPLOAD_IMAGE_FAILED';


export const UploadImageAction = (data: any, callbackFunction:any) => {
    return { type: UPLOAD_BANNER_IMAGE_REQUEST, payload: data, callbackFunction }
}
